module.exports = __webpack_public_path__ + "img/menu-icon.3091b080.svg";